import { formatCheckedAgo } from "../profile/format-checked-ago";
import type { Availability } from "../profile/types";

export function AvailabilityFreshness({
    availability,
    listingCount,
}: {
    availability: Availability;
    listingCount: number | null;
}) {
    const relative = formatCheckedAgo(availability.lastCheckedAt, "relative");
    if (!relative && listingCount == null) return null;
    const parts = [
        listingCount != null ? `${listingCount} available` : null,
        relative,
    ].filter(Boolean);
    return (
        <p className="text-body-small text-doberman-black/45 tabular-nums">
            {parts.join(" · ")}
        </p>
    );
}
